/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Thejashiwini M's Portfolio",
  description:
    "ECE student with a strong interest in IoT systems, embedded technologies, and web automation. Skilled in Python, C, Arduino, and sensor-based data processing.",
  og: {
    title: "Thejashiwini M Portfolio",
    type: "website",
    url: "https://github.com/Theja404error",
  },
};

//Home Page
const greeting = {
  title: "Thejashiwini M",
  logo_name: "ThejashiwiniM",
  nickname: "",
  subTitle:
    "ECE student with a strong interest in IoT systems, embedded technologies, and web automation. Skilled in Python, C, Arduino, and sensor-based data processing.",
  resumeLink:
    "my_resume.pdf", // Updated to point to your resume file
  portfolio_repository: "https://github.com/Theja404error/my-portfolio",
  githubProfile: "https://github.com/Theja404error",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/Theja404error",
    fontAwesomeIcon: "fa-github",
    backgroundColor: "#181717",
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/thejashwini-m-6686b7376/",
    fontAwesomeIcon: "fa-linkedin-in",
    backgroundColor: "#0077B5",
  },
  {
    name: "Gmail",
    link: "mailto:thejashwini7676527122@gmail.com",
    fontAwesomeIcon: "fa-google",
    backgroundColor: "#D14836",
  },
  {
    name: "Phone",
    link: "tel:+917676527122",
    fontAwesomeIcon: "fa-phone",
    backgroundColor: "#25D366",
  },
];

const skills = {
  data: [
    {
      title: "IoT & Embedded Systems",
      fileName: "DataScienceImg",
      skills: [
        "⚡ IoT systems design and development",
        "⚡ Arduino and sensor-based data processing",
        "⚡ Environmental monitoring systems",
        "⚡ Real-time embedded applications",
        "⚡ Automation tools and web scraping",
      ],
      softwareSkills: [
        { skillName: "Python", fontAwesomeClassname: "ion-logo-python" },
        { skillName: "C", fontAwesomeClassname: "logos-c" },
        { skillName: "Arduino IDE", fontAwesomeClassname: "simple-icons:arduino" },
        { skillName: "HTML", fontAwesomeClassname: "simple-icons:html5" },
        { skillName: "CSS", fontAwesomeClassname: "simple-icons:css3" },
        { skillName: "JavaScript", fontAwesomeClassname: "ion-logo-javascript" },
        { skillName: "SQL", fontAwesomeClassname: "simple-icons:mysql" },
        { skillName: "Git", fontAwesomeClassname: "fa-git" },
        { skillName: "VS Code", fontAwesomeClassname: "simple-icons:visualstudiocode" },
      ],
    },
    {
      title: "Core Competencies",
      fileName: "FullStackImg",
      skills: [
        "⚡ Teamwork and Collaboration",
        "⚡ Active Learner with Strong Work Ethic",
        "⚡ Time Management and Organization",
        "⚡ Critical Thinking and Problem Solving",
      ],
      softwareSkills: [],
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Sri Venkateshwara College of Engineering (SVCE)",
      subtitle: "B.E in Electronics and Communication Engineering (ECE)",
      logo_path: "",
      alt_name: "Sri Venkateshwara College of Engineering",
      duration: "2023–2027 (Present)",
      descriptions: [
        "CGPA: 8.95"
      ],
      website_link: "",
    },
    {
      title: "Advithya PU College",
      subtitle: "PCMB Stream",
      logo_path: "",
      alt_name: "Advithya PU College",
      duration: "Completed 2023",
      descriptions: [
        "Percentage: 80%"
      ],
      website_link: "",
    },
  ],
};

const experience = {
  title: "Experience",
  subtitle: "Work Experience",
  description:
    "Building PatentBug, an AI-powered platform for patent analysis and innovation insights.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "CEO",
          company: "PatentBug",
          company_url: "",
          logo_path: "developerActivity.svg",
          duration: "Jan 2026 - Current",
          location: "",
          description:
            "Founded and leading PatentBug, leveraging AI and IoT expertise to revolutionize patent analysis and innovation discovery.",
          color: "#000000",
        },
      ],
    },
  ],
};

const projectsHeader = {
  title: "Projects",
  description:
    "IoT and embedded systems projects including railway defect detection, environmental monitoring, and web automation tools.",
  avatar_image_path: "",
  github_profile_link: "https://github.com/Theja404error",
};

const publicationsHeader = {
  title: "Patents & Publications",
  description: "AI-Powered Patents and Published Work",
  avatar_image_path: "",
};

const publications = {
  data: [
    { 
      name: "AI-Powered Test Case Generator",
      description: "Patent No: 202641013759",
      image_path: "patent/202641013759 patent 4.jpg"
    },
    {
      name: "Advance Automation Tool For Web Scraping, Web Testing and Intelligent Bot Creation",
      description: "Published in Springer Nature"
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "",
    description:
      "Bangalore – 562114 | +91-7676527122 | thejashwini7676527122@gmail.com",
  },
  blogSection: {
    title: "",
    subtitle: "",
    link: "",
    avatar_image_path: "",
  },
  addressSection: {
    title: "Address",
    subtitle: "Bangalore – 562114",
    locality: "Bangalore",
    country: "India",
    region: "Karnataka",
    postalCode: "562114",
    streetAddress: "",
    avatar_image_path: "address_image.svg",
    location_map_link: "",
  },
  phoneSection: {
    title: "Phone",
    subtitle: "+91-6381505907",
  },
};

const competitiveSites = { competitiveSites: [] };
const certifications = { certifications: [] };

const projects = {
  data: [
    {
      id: "1",
      name: "RailNeuron — Railway Defect Detection System",
      url: "https://github.com/Theja404error/Railneuron",
      description: "Developed an IoT edge-AI framework on Raspberry Pi using 1D-CNN (98.47% accuracy) and Autoencoder for real-time rail crack and bearing fault classification. Achieved cost-efficient deployment (<₹50K per node) with live dashboard, multi-channel alerts, and online learning capabilities.",
      languages: ["Python", "Arduino", "IoT", "CNN", "Machine Learning"],
    },
    {
      id: "2",
      name: "matocr8d — OCR Library",
      url: "https://github.com/Akshay404error/openmarine8d",
      description: "A simple and easy-to-use OCR (Optical Character Recognition) library for Python leveraging the Tesseract OCR engine for efficient text extraction from images.",
      languages: ["Python", "OCR", "Tesseract"],
    },
    {
      id: "3",
      name: "Microplastic Pollution in Aquatic Ecosystem",
      url: "https://github.com/Theja404error/Micro-plastic-software",
      description: "Conducted a comprehensive study on microplastic pollution and its impact on aquatic life. Proposed sensor-based and data-driven alternatives for improved monitoring of environmental pollution.",
      languages: ["Python", "Data Analysis", "IoT Sensors", "Environmental Science"],
    },
    {
      id: "4",
      name: "AutoScrap: Web Scraping Automation for Everyone",
      url: "https://github.com/Akshay404error/Web-Scraping-Automation-for-Everyone",
      description: "Developed a lightweight Python-based library for simplified and efficient web scraping automation. Designed for ease of use while maintaining robust performance for production environments.",
      languages: ["Python", "Web Automation", "Scraping"],
    },
  ],
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
  projects,
};
